import { DownloadIcon } from "./assets/DownloadIcon";
import s from "./ReportDownloadButton.module.scss";

interface IProps {
  onExport: () => void;
}
export const ReportDownloadButton = ({ onExport }: IProps) => {
  return (
    <div onClick={onExport} className={s.left}>
      <DownloadIcon />
      <span>Download</span>
    </div>
  );
};
